import {useDerivedProduct as useDerivedProductBase} from '@salesforce/retail-react-app/app/hooks/use-derived-product';
import {isSimpleProduct as checkIsSimpleProduct} from '@amblique/king-living/app/utils/product-utils';

/**
 * @override
 *  - Add simple and complex product detection based on c_simpleProduct attribute
 *  - Overrides the base hook's isSimpleProduct which is based on variation attributes
 *
 * @param {object} product
 * @param {boolean} isProductPartOfSet
 * @param {boolean} isProductPartOfBundle
 * @returns {object}
 */
export const useDerivedProduct = (
  product,
  isProductPartOfSet = false,
  isProductPartOfBundle = false
) => {
  const derivedProduct = useDerivedProductBase(product, isProductPartOfSet, isProductPartOfBundle);

  // Use custom isSimpleProduct check based on c_simpleProduct attribute
  // instead of the base hook's check which is based on variation attributes
  const isSimpleProduct = checkIsSimpleProduct(product);
  const isComplexProduct = !isSimpleProduct;

  return {
    ...derivedProduct,
    isSimpleProduct,
    isComplexProduct,
  };
};
